<template>
  <div class="test_format_box">
    <div class="test_format_top_text">
      {{ segments.level_desc }}
    </div>
    <el-table
      :data="tableData"
      :span-method="handleSpanMethod"
      :show-header="false"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column width="169px" prop="segment_name" header-align="center" align="center">
        <template slot-scope="scope">
          <div>
            <img
              class="segment_img"
              :src="require(`@/assets/images/hsk/${scope.row.segment_code}.png`)"
              alt=""
            />
            <div class="segment_text">{{ getSegmentName(scope.row.segment_name) }}</div>
            <div class="segment_score">100{{ $t('hsk_point') }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="part_title" header-align="center" align="left">
        <template slot-scope="scope">
          <div class="part_box">
            <div>
              <div class="part_title">{{ scope.row.part_title }}</div>
              <div class="part_desc">{{ scope.row.part_desc }}</div>
            </div>
            <section v-if="!isHideExample">
              <div v-if="scope.row.practiced" class="examples_text">
                <div @click="seeResult(scope.row)">{{ $t('test_has_practiced') }} ></div>
                <!-- <SvgIcon type="arrow-right" class="icon-18"></SvgIcon> -->
              </div>
              <div v-else class="examples_text" @click="goPractice(scope.row)">
                {{ $t('Examples') }}>
              </div>
            </section>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="isShowDesc"
        width="604px"
        prop="segment_desc"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="segment_desc_con">
            <div class="segment_desc">{{ scope.row.segment_desc }}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { apiRequest } from '@/serves/http'
import { mapState } from 'vuex'
import { hidetestTabelExpleList, showtestTableDescList } from '@/utils/hskTool'
import { transferLanguage } from '@/utils/utils'
export default {
  props: {
    segments: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableData: [],
      level: '',
    }
  },
  watch: {
    segments: {
      handler(newVal) {
        console.log('segments=======', newVal)
        this.initData(newVal.segments)
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState({
      levelActiveIndex: (state) => state.level.levelActiveIndex,
    }),
    computedLevelIndex() {
      return Number(this.levelActiveIndex || localStorage.getItem('LevelActiveId'))
    },
    isHideExample() {
      return hidetestTabelExpleList.some((item) => item === this.level)
    },
    isShowDesc() {
      return showtestTableDescList.some((item) => item === this.level)
    },
  },
  mounted() {
    this.level = this.$route.query.level
    // this.getPaperDetails()
  },
  methods: {
    getSegmentName(name) {
      return this.$t(name)
    },
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'segment_name' || column.property === 'segment_desc') {
        // 判断当前行的 segment_name 是否和上一行相同
        if (rowIndex === 0 || row.segment_name !== this.tableData[rowIndex - 1].segment_name) {
          // 返回当前列所占的行数
          const rowspan = this.tableData.filter(
            (item) => item.segment_name === row.segment_name
          ).length
          return {
            rowspan,
            colspan: 1,
          }
        } else {
          // 返回当前单元格不需要渲染
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    initData(data) {
      this.tableData = []
      data.forEach((segments) => {
        // console.log('segments------forEach', segments)
        segments.parts.forEach((part) => {
          // console.log('part==========', part)
          const description = transferLanguage(segments.segment_desc)
          this.tableData.push({
            segment_code: segments.segment_code,
            segment_name: segments.segment_name,
            segment_desc: description,
            score: 100,
            part_title: part.part_title,
            part_desc: part.part_desc,
            part_code: part.part_code,
            practiced: part.practiced,
          })
        })
      })
      console.log('处理过的数据== this.tableData', this.tableData)
    },
    // 隐藏掉不需要的表头
    discountHeaderStyle({ rowIndex }) {
      // if (rowIndex == 1) {
      return { display: 'none' }
      // }
    },
    // 去练习
    goPractice(row) {
      utilV2.postData(
        ApiPath.hsk_init_practise,
        {
          level: this.segments.level_name,
          segment: row.segment_code,
          part: row.part_code,
        },
        (data) => {
          this.getUpgradeResourceData(
            data.resourceUrl,
            row.segment_code,
            row.part_code - 1,
            data.paperId,
            false,
            this.computedLevelIndex + 1
          )
        }
      )
    },
    getUpgradeResourceData(
      resourceUrl,
      name_code,
      id,
      paperId,
      ifCheckRecord,
      level,
      examinationId
    ) {
      utilV2.getJSON(`${resourceUrl.slice(0, -4)}/index.json`, (data) => {
        this.resourceList = []
        // 重新组装索引页数据
        let tempArr = []
        let Data = []
        for (let i = 0; i < data.items.length; i++) {
          if (tempArr.indexOf(data.items[i].segment_code) === -1) {
            Data.push({
              name: data.items[i].segment_code,
              nameStr: this.findSegmentCodeStr(data.items[i].segment_code),
              dataInfo: [data.items[i]],
            })
            tempArr.push(data.items[i].segment_code)
          } else {
            for (let j = 0; j < Data.length; j++) {
              if (Data[j].name == data.items[i].segment_code) {
                Data[j].dataInfo.push(data.items[i])
                break
              }
            }
          }
        }
        // 取出所有题型的题目 再次重新拼凑
        let quesList = []
        Data.forEach((itemData) => {
          itemData.dataInfo.forEach((data) => {
            quesList.push(this.apiRequest(data.topic_items, resourceUrl))
          })
        })
        Promise.all(quesList).then((res) => {
          let i = 0
          Data.forEach((text) => {
            let typeList = []
            text.dataInfo.forEach((data) => {
              //  套题获取逻辑修改
              let fnlData = []
              //两种题型在同一部分时，bigIndex不置空
              if (typeList.indexOf(data.part_code) === -1) {
                typeList.push(data.part_code)
                this.bigIndex = 0
              }
              res[i]
                .filter((data) => !data.is_example)
                .forEach((item) => {
                  if (item.questions) {
                    this.bigIndex++
                    // 如果是套题的情况
                    let quesGroupist = JSON.parse(JSON.stringify(item.questions))
                    item.questions.forEach((g, index) => {
                      g.topic_type = data.topic_type
                      g.questions = quesGroupist
                      g.part_code = data.part_code
                      g.segment_code = data.segment_code
                      g.ifGroup = true // 是否套题
                      g.num = item.questions.length - index // 当前套题剩余题数量(用于正向下一题使用)
                      g.nnum = index + 1 // 当前套题剩余题数量(用于反向上一题使用)
                      g.bigIndex = this.bigIndex
                      g.top_listen = item.listen
                      g.top_screen_text = item.screen_text
                      item.config && g.config && Object.assign(g.config, item.config)
                      fnlData.push(g)
                    })
                    this.bigIndex += item.questions.length - 1
                  } else {
                    this.bigIndex++
                    item.topic_type = data.topic_type
                    item.part_code = data.part_code
                    item.segment_code = data.segment_code
                    item.ifGroup = false
                    item.num = 1
                    item.nnum = 1
                    item.bigIndex = this.bigIndex
                    fnlData.push(item)
                  }
                })
              i++
              data.questionList = fnlData
            })
          })
          this.upgradeDataList = Data
          this.upgradeDataList.forEach((item) => {
            item.dataInfo = this.apartPartData(item.dataInfo)
          })
          console.log('排查问题用', this.upgradeDataList, name_code)
          let jsonObj = this.upgradeDataList.find((item) => {
            return item.name == name_code
          })
          let json = jsonObj.dataInfo[id]
          console.log(json)
          if (!json.questionList[0].questions) {
            json.questionList = json.questionList.filter((item) => {
              return !item.is_example
            })
          }
          if (!ifCheckRecord) {
            let params = {
              jsonData: { ...json },
              answerNotesArray: [],
            }
            localStorage.setItem('practiceJson', JSON.stringify(params))
            //跳转答题
            this.$router.push({
              name: 'ExaminationUpgrade',
              query: {
                root_path: resourceUrl.slice(0, -4) + '/',
                paperId: paperId,
                level: level,
                part: id + 1,
                exam_type: this.segments.level_name,
                section: name_code == 'write' ? 'writing' : name_code + 'ing',
              },
            })
          } else {
            //跳转查看记录
            utilV2.getData(
              ApiPath.hsk_practise_answer,
              {
                examinationId,
              },
              (data) => {
                this.answerNotesArray = data.questionAnswers
                // 得到记录合并对象
                if (this.answerNotesArray.length) {
                  let filterQuestionList = json.questionList.filter((item) => {
                    return !item.is_example
                  })
                  filterQuestionList.forEach((eg, egIndex) => {
                    this.answerNotesArray[egIndex].nnum = eg.nnum
                    this.answerNotesArray[egIndex].num = eg.num
                    this.answerNotesArray[egIndex].ifGroup = eg.ifGroup
                    Object.assign(eg, this.answerNotesArray[egIndex])
                  })
                }

                console.log('json=====', json)
                let params = {
                  jsonData: { ...json },
                  answerNotesArray: this.answerNotesArray,
                }
                localStorage.setItem('practiceJson', JSON.stringify(params))
                this.dialogPracticeTableVisible = false
                this.$router.push({
                  name: 'ExaminationUpgrade',
                  query: {
                    root_path: resourceUrl.slice(0, -4) + '/',
                    paperId: paperId,
                    currentQuesIndex: 1,
                    paperStatus: 1,
                    report: true,
                    level: level,
                    ifRecord: true,
                  },
                })
              }
            )
          }
        })
      })
    },
    apiRequest(name, resourceUrl) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        let result
        await utilV2.getJSON(`${resourceUrl.slice(0, -4)}/${name}`, (data) => {
          result = data.items
        })
        resolve(result)
      })
    },
    apartPartData(list) {
      let typeList = [] //定义空数组，用于装载去重之后的数组，
      let returnList = [] //返回的数组
      if (list) {
        //如果有值
        list.forEach((item, index) => {
          //可以用indexOf()数组去重 如果检索的结果匹配到,则返回 1. 如果检索的结果没有匹配值,则返回 -1.
          if (typeList.indexOf(item.part_code) === -1) {
            typeList.push(item.part_code)
            this.$set(returnList, index, item)
          } else {
            this.$set(returnList, index - 1, {
              ...returnList[index - 1],
              questionList: returnList[index - 1].questionList.concat(item.questionList),
            })
          }
        })
      }
      return returnList
    },
    seeResult(row) {
      utilV2.getData(
        ApiPath.hsk_practise_record,
        {
          level: this.segments.level_name,
          segment: row.segment_code,
          part: row.part_code,
        },
        (data) => {
          this.handleCheckRecord(data[0])
        }
      )
    },
    handleCheckRecord(row) {
      this.getUpgradeResourceData(
        row.resourceUrl,
        row.segment,
        row.part - 1,
        row.paperId,
        true,
        this.computedLevelIndex + 1,
        row.examinationId
      )
    },
    findSegmentCodeStr(code) {
      let codeStr = ''
      switch (code) {
        case 'listen':
          codeStr = this.$t('hsk_listen_name')
          break
        case 'read':
          codeStr = this.$t('hsk_read_name')
          break
        case 'write':
          codeStr = this.$t('hsk_write_name')
          break

        default:
          break
      }
      return codeStr
    },
  },
}
</script>
<style scoped lang="scss">
.test_format_top_text {
  color: #2c2f46;
  font-size: 16px;
  font-weight: 400;
}
.segment_img {
  width: 38px;
  height: 38px;
}
.segment_text {
  color: #2c2f46;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  margin-top: 7px;
}
.segment_score {
  color: #2c2f46;
  font-size: 14px;
  line-height: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 15px;
}
.part_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding-right: 13px;
  margin-top: 14px;
  margin-bottom: 13px;
  .part_title {
    color: #2c2f46;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  .part_desc {
    color: #696974;
    font-size: 16px;
    font-weight: 400;
    word-break: keep-all;
  }
  .examples_text {
    min-width: 100px;
    color: #2c2f46;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    text-decoration-line: underline;
  }
}
.segment_desc_con {
  padding: 22px;
  .segment_desc {
    color: #696974;
    font-size: 16px;
    font-weight: 400;
    word-break: keep-all;
  }
}

::v-deep .el-table tbody tr:hover > td {
  background-color: transparent !important;
}

::v-deep .el-table__body {
  @media screen and (max-width: 768px) {
    width: 100% !important;

    colgroup {
      & > col:nth-of-type(1) {
        width: 70px;
      }
      & > col:nth-of-type(2) {
        width: auto;
      }
      & > col:nth-of-type(3) {
        width: 100px;
      }
    }

    tbody {
      & > tr {
        & > td:nth-of-type(1) {
          vertical-align: top;

          & > div {
            padding-top: 16px;
          }
        }

        & > td:nth-of-type(3) {
          & > .cell {
            padding: 0 10px;

            & > div{
              padding: 0px;

              & > div {
                word-break: break-all;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #fff;
}
</style>
